import { KeyboardEvent } from 'react';
import { useStepsStore } from '../stores/StepsStore';

const Step_DeviceId = (props: { onNext: () => void; }) => {
  const { setDeviceId, deviceId, error } = useStepsStore();

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      props.onNext();
    }
  };

  return (
    <div>
      <div className='margin-top'>
        <h2 className='ncf-title'>Welcome to Careline365</h2>
        <p className='step-explain'>Please complete our registration to activate your alarm and connect you to our 24/7 Care Team.</p>
      </div>
      <form className="simple-form">
        <span className='ncf-subtitle bold'>First, we need to activate your personal alarm</span>
        <label htmlFor="name">Please enter your activation code below:</label>
        <input id="name" type="text" className='input-short' value={deviceId ?? ''}
          onKeyDown={ handleKeyDown }
          autoComplete='off' onChange={(e) => setDeviceId(e.target.value)}
          placeholder="_ _ _ _ _ _ _ _ _" required />
        <p className='step-explain explain-small'>Your activation code begins with either a SC or TD followed by 7 numbers. You can find your code on the side of the box your alarm device or base unit came in.</p>
      </form>
      {error !== '' ? <div className="error" dangerouslySetInnerHTML={{ __html: error}}></div> : ''}
    </div>
  );
};

export default Step_DeviceId;